import styled from 'styled-components';
import { Row } from 'react-materialize';

export default styled(Row)`
  margin-left: -0.75rem !important;
  margin-right: -0.75rem !important;
  margin-bottom: 0;
  ${props => props.margin ? (`margin: ${props.margin};`) : ''};
`;
